import { Component, OnInit } from '@angular/core';
import { routerTransition } from '@app/router.animations';
import { ToastrService } from 'ngx-toastr';
import { ConsultingService, LoaderService, ReportService } from '@app/shared/services';
import { PageHeaderComponent } from '@app/components/page-header/page-header.component';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { UtilsInjectable } from '@app/shared';
import { provideNgxMask } from 'ngx-mask';

@Component({
    selector: 'app-receipts',
    templateUrl: './receipts.component.html',
    styleUrls: ['./receipts.component.scss'],
    animations: [routerTransition()],
    imports: [CommonModule, FormsModule, PageHeaderComponent, SelectDropDownModule],
    providers: [DatePipe, provideNgxMask()],
})
// ...imports same as before

export class ReceiptsComponent implements OnInit {

    public user_rights: any = {};
    public receipt_list: any[] = [];
    public customer_options: any[] = [];
    public customer_data: any;
    public invoices_list: any[] = [];
    public total_adjusted = 0;

    public receipts: any = {
        receipt_no: '',
        receipt_type: 'Cash',
        receipt_date: this.getToday(), // string format
        receipt_amount: '',
        edit_status: 0
    };

    constructor(
        private loaderService: LoaderService,
        private consultingService: ConsultingService,
        private toastr: ToastrService,
        protected utils: UtilsInjectable,
        private reportService: ReportService
    ) {}

    ngOnInit() {
        this.listCustomer();
        this.getReceiptList();
        this.user_rights = JSON.parse(localStorage.getItem('user_rights') || '{}');
        if(!this.receipts.edit_status){
            this.getReceiptNo();
        }
    }

    listCustomer() {
        this.loaderService.display(true);
        this.reportService.listCustomer().subscribe((res: any) => {
            this.loaderService.display(false);
            if(res.status === 'Success'){
                this.customer_options = res.data;
            }
        });
    }

    getCustomerInvoices() {
        if(!this.customer_data?.CUSTOMER_ID) return;
        const postData = { customer_id: this.customer_data.CUSTOMER_ID };
        this.loaderService.display(true);
        this.consultingService.listCustomerInvoices(postData).subscribe((res: any) => {
            this.loaderService.display(false);
            if(res.status === 'Success' && res.data.length){
                this.invoices_list = res.data.map((inv:any) => ({
                    ...inv,
                    adjust_amount: 0,
                    checked: false
                }));
            } else {
                this.invoices_list = [];
                this.toastr.warning('No invoices found for this customer.');
            }
        });
    }

    selectReceiptType(type: any) {
        this.receipts.receipt_type = type;
    }

    getToday(): string {
        return new Date().toISOString().split('T')[0];
    }

    numberOnly(event: KeyboardEvent) {
        const charCode = event.which ? event.which : event.keyCode;
        if(charCode < 48 || charCode > 57){
            event.preventDefault();
            return false;
        }
        return true;
    }

    recalculateTotal() {
        this.total_adjusted = this.invoices_list.reduce((sum, inv) => inv.checked ? sum + (Number(inv.adjust_amount) || 0) : sum, 0);
    }

    getTotalBalance() {
        return this.invoices_list.reduce((sum, inv) => sum + (Number(inv.INVOICE_AMOUNT) - (Number(inv.adjust_amount) || 0)), 0);
    }

    autoDistributeAmount() {
        let remaining = Number(this.receipts.receipt_amount) || 0;
        this.invoices_list.forEach(inv => {
            inv.checked = false;
            inv.adjust_amount = 0;
            if(remaining > 0){
                const available = Number(inv.INVOICE_AMOUNT);
                const adjust = Math.min(available, remaining);
                inv.adjust_amount = adjust;
                inv.checked = true;
                remaining -= adjust;
            }
        });
        this.recalculateTotal();
    }

    saveReceipt() {
        if(!this.customer_data?.CUSTOMER_ID){
            this.toastr.error('Please select a customer!');
            return;
        }
        if(!this.receipts.receipt_type){
            this.toastr.error('Please choose receipt type!');
            return;
        }
        if(!this.receipts.receipt_date){
            this.toastr.error('Please select date!');
            return;
        }
        if(!this.receipts.receipt_amount){
            this.toastr.error('Please enter amount!');
            return;
        }

        const adjustedInvoices = this.invoices_list
            .filter(inv => inv.checked && inv.adjust_amount > 0)
            .map(inv => ({ invoice_id: inv.INVOICE_ID, adjust_amount: inv.adjust_amount }));

        const payload = {
            ...this.receipts,
            customer_id: this.customer_data.CUSTOMER_ID,
            adjusted_invoices: adjustedInvoices
        };

        this.loaderService.display(true);
        this.consultingService.saveReceipt(payload).subscribe((res:any) => {
            this.loaderService.display(false);
            if(res.status === 'Success'){
                this.toastr.success(res.msg);
                this.clear();
                this.getReceiptList();
            } else {
                this.toastr.error(res.msg);
            }
        });
    }
    getReceiptNo(){
        this.consultingService.getReceiptNo().subscribe((result: any) => {
            if (result['status'] == 'Success') {
                this.receipts.receipt_no = result['receipt_no'];
            }
        });
    }
    clear() {
        this.receipts.receipt_type = 'Cash';
        this.receipts.receipt_date = this.getToday();
        this.receipts.receipt_amount = '';
        this.receipts.edit_status = 0;
        this.customer_data = null;
        this.invoices_list = [];
        this.total_adjusted = 0;
        this.getReceiptNo();

    }

    getReceiptList() {
        this.consultingService.getReceiptList().subscribe((res:any)=>{
            if(res.status==='Success') this.receipt_list = res.data;
        });
    }
}

